<template active-class="ColumnContainer">
  <div class="ColumnContainer">
    <common ref="common" />
    <div class="ScrollContainer padding-style">
      <!-- <v-row no-gutters>
        <v-col> -->
      <div class="d-flex align-content-start flex-wrap">
        <v-img src="../../assets/404.svg" :aspect-ratio="1.7" contain> </v-img>
      </div>
      <div class="title title-style">Page Not Found</div>
      <!-- </v-col>
      </v-row> -->
    </div>
  </div>
</template>
<script>
import common from "@/components/tools/common";
export default {
  components: { common },
  data() {
    return {};
  },
  mounted() {
    // this.GetOrganizationInfo();
    // this.shareBtnVisible = navigator.canShare;
  },
  watch: {},
  methods: {},
};
</script>

<style>
.title-style {
  text-align: center;
  padding: 20px;
}
.padding-style {
  padding-top: 150px;
  padding-left: 50px;
  padding-right: 50px;
}
</style>